import fetch from '../utils/fetch';
import CustomError from '../utils/CustomError';
import { UNEXPECTED_ERROR, TRANSACTION_ID } from '../constants/services';
import { configurationEndpointV3 } from '../constants/endpoints';

export async function getAuditableElements(token, applicationName) {
  try {
    const query = await fetch(configurationEndpointV3, {
      token,
      params: {
        applicationName
      }
    });
    const transactionId = query.headers.get(TRANSACTION_ID);
    const json = await query.json();
    if (json.error) {
      throw new CustomError({ ...json, transactionId });
    }

    return json.data[0];
  } catch (err) {
    if (err.isCustomError) {
      throw err;
    }
    throw new CustomError(UNEXPECTED_ERROR);
  }
}
export default getAuditableElements;
